const awsmobile = {
  aws_project_region: "us-east-1",
  aws_cognito_region: "us-east-1",
  aws_user_pools_id: process.env.REACT_APP_AMPLIFY_USERPOOL_ID,//"us-east-1_P08FsiFUH",
  aws_user_pools_web_client_id: process.env.REACT_APP_AMPLIFY_WEBCLIENT_ID,//"2pq499f2rh4nkt6nggslv8q1h0",
};

export default awsmobile;
